<template>
    <div>   
        <h2 class="primary darken-2 white--text font-weight-bold subheading pt-1 text-xs-center">
            Withdrawal History
        </h2>
        <v-divider></v-divider>
        <div class="" style="max-height: 400px; overflow: auto"> 
            <v-card 
                color="white" 
                v-for="transaction in transactions"
                :key="transaction.id"
                class="mb-1"
            >
                <v-card-text class="px-3 py-2" style="font-size: 12px; cursor: pointer">
                    <h2 class="teal--text">
                        Status: 
                        <span :class="statusColorClass(transaction.status)">
                            {{ transactionStatus(transaction.status) }}
                        </span>
                    </h2>
                    
                    <div class="mt-1">
                        <b>Amount:</b> {{ transaction.amount }} FCFA
                    </div>
                    
                    <div class="mt-1">
                        <b>Date:</b> {{ formatDate(transaction.date) }} at {{ transaction.time }}
                    </div>
                    
                    <v-spacer></v-spacer>
                    
                    <div class="mt-1">
                        <span v-if="transaction.payment_method">
                            <b>Method:</b> 
                            {{ transaction.payment_method }} 
                            <span v-if="transaction.user_phone">({{ transaction.user_phone }})</span>
                        </span>

                    </div>
                                        <div class="mt-1">

                        <span v-if="transaction.reference"  class="mt-1">
                            <b>ref:</b> {{ transaction.reference }}
                        </span>
                    </div>
                    <div class="mt-1">
                        <span v-if="transaction.description">
                            <b>Description:</b> {{ transaction.description }}
                        </span>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
            </v-card>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            transactions: []
        }
    },

    methods: {
        async getWithdrawalHistory() {
            try {
                const response = await axios.get(
                    '/api/v1/home/get/user/transactions/null/null/withdrawals/'
                )
                this.transactions = response.data.results
            } catch (error) {
                this.handleError(error)
            }
        },

        statusColorClass(status) {
            return {
                'PENDING': 'blue--text',
                'COMPLETED': 'success--text',
                'CANCELLED': 'red--text',
                'APPROVED': 'blue--text',
                'REJECTED': 'grey--text'
            }[status] || 'grey--text'
        },

        transactionStatus(status) {
            return {
                'PENDING': 'Pending',
                'COMPLETED': 'Completed',
                'CANCELLED': 'Cancelled',
                'APPROVED': 'Approved',
                'REJECTED': 'Rejected'
            }[status] || status
        },

        formatDate(dateStr) {
            const options = { year: 'numeric', month: 'short', day: 'numeric' }
            return new Date(dateStr).toLocaleDateString('fr-FR', options)
        },

        handleError(error) {
            const message = error.response 
                ? `${error.response.status} - ${error.response.data.error || 'Server error'}`
                : 'Connection error'
            
            this.$store.commit('setSnackBarMessage', message)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
        }
    },

    mounted() {
        this.getWithdrawalHistory()
        document.title = "PettyCash | Withdrawal History"
        this.$store.commit('setCloseURL', "/home/withdrawals/history")
    }
}
</script>

<style scoped>
.v-card {
    transition: all 0.3s ease;
}

.v-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
}

.teal--text {
    font-size: 14px;
    margin-bottom: 8px;
}

.mt-1 {
    margin-top: 4px;
}
</style>